namespace TabAurous.SalesOrder {
    export namespace OrderItemsForSalesService {
        export const baseUrl = 'SalesOrder/OrderItemsForSales';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<SalesOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "SalesOrder/OrderItemsForSales/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OrderItemsForSalesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
